module.exports = __webpack_public_path__ + "static/media/volume-medium.e6dc4dca.svg";